import { IShader, ShaderBase } from '../shader';
import { Scene, StandardMaterial, Color3, Material } from '@babylonjs/core';

export class ShaderSlot extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = '';
    public text: string = '';

    public get key(): string { return 'ShaderSlot'; }

    public getMaterial(scene: Scene, light: string = ''): StandardMaterial {
        const material = new StandardMaterial('material', scene);
        material.emissiveColor = new Color3(0, 1 / 3, 0);
        material.alpha = 0.7;
        return material;
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        return material;
    }
}
